import { ChangeDetectionStrategy, Component } from '@angular/core';
import { createProvider, Step } from '../../../../../../shared/IFE/step/step/step';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { ChargingStationDistance } from '../../../../../../shared/modules/evc-api/models/constants';
import { AnalyticsService } from '../../../../../../shared/modules/analytics/services/analytics.service';

@Component({
  selector: 'evc-quote-technical-details-distance',
  providers: [createProvider(DistanceComponent)],
  templateUrl: './distance.component.html',
  styleUrls: ['./distance.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DistanceComponent extends Step {
  readonly formName = 'evcQuote';
  readonly stepName: string = 'technical-details-distance';

  constructor(fb: UntypedFormBuilder, analyticsService: AnalyticsService) {
    super(fb, analyticsService);
  }

  writeValue(value): void {
    if (!value) {
      super.writeValue(value);
      return;
    }

    // We can expect a '.simulation' when we visit it for the first time. When it is not the first time, we just write the value.
    if (typeof value === 'string' && value.includes('.simulation')) {
      value = value.split('.');
      switch (value[0]) {
        case ChargingStationDistance.lessThan5:
          super.writeValue({ value: 5 });
          break;
        case ChargingStationDistance.from5to15:
          super.writeValue({ value: 10 });
          break;
        case ChargingStationDistance.moreThan15:
          super.writeValue({ value: 15 });
          break;
      }
      this.onTouch();
      this.onModelChange(this.control.get('value').value);
    } else {
      super.writeValue({ value });
    }
  }

  allowDigitsOnly(event): boolean {
    return Number(event.key) >= 0;
  }

  public navigate(): void {
    if (this.control.valid) {
      this.onTouch();
      this.valueChanges(this.control.get('value').value);
    }
    super.navigate();
  }

  protected buildForm() {
    this.control = this.fb.group({
      value: this.fb.control('', [Validators.required]),
    });
  }
}
